module.exports = __webpack_public_path__ + "static/media/thumbnail.30d7cd8e.jpg";